'use client';

import { useCallback, useState } from 'react';

import Image from 'next/image';

import { Carousel } from '@/components/common';
import { HeaderText, Modal } from '@/components/ui';
import { HeaderSize } from '@/components/ui/HeaderText';

import {
  TypeModalCarouselFields,
  TypeModalVideoFields,
} from '@/core/generated-types';

import {
  CLICKED_ITEM_TYPES,
  CTA_NAMES,
  ITEM_EVENT_TYPES,
  PAGE_LOCATIONS,
  track,
} from '@/utils/rudderstack';
import { getMediaComponent } from '@/components/common/LandingPageHero/utils';

import PlayButtonIcon from '@/public/assets/icons/play-button.svg';
interface MediaTextTitleModalInterface {
  fields: TypeModalVideoFields | TypeModalCarouselFields;
}

function MediaTextTitleModal({ fields }: MediaTextTitleModalInterface) {
  const { openModalCta, title } = fields;

  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = useCallback(() => {
    // Use fixed values for cta due to translation for different languages
    const ctaName =
      'video' in fields ? CTA_NAMES.SEE_IT_IN_ACTION : CTA_NAMES.LOOK_INSIDE;

    track(ITEM_EVENT_TYPES.ITEM_CLICKED, {
      type: CLICKED_ITEM_TYPES.BUTTON,
      cta: ctaName,
      pageLocation: PAGE_LOCATIONS.READING_SKILL_SET_PAGE,
      url: window.location.href,
      title,
    });

    setIsOpen((isOpen) => !isOpen);
  }, [fields, title]);

  return (
    <div className="mt-auto" data-testid="mediaTextTitleModal">
      <button
        onClick={toggleModal}
        className="flex items-center gap-2 hover:opacity-80 text-blue-deep text-lg font-bold"
      >
        {'video' in fields && (
          <Image src={PlayButtonIcon} alt="Video Play icon" />
        )}

        {openModalCta}
      </button>
      <Modal
        isOpen={isOpen}
        handleClose={toggleModal}
        modalClasses={{
          desktop: {
            minWidth: '37.5rem',
            width: '55%',
            maxWidth: '45%',
          },
          mobile: {
            paddingBottom: '0',
          },
        }}
        contentClasses="-mx-4 md:-mx-0 lg:w-full"
      >
        <HeaderText
          size={HeaderSize.H3}
          text={title}
          align="center"
          classes="mt-6 mb-5"
        />

        {'carousel' in fields && <Carousel {...fields.carousel.fields} />}
        {'video' in fields &&
          getMediaComponent({
            media: fields.video,
            classes: 'h-full object-cover w-full aspect-[1/1]',
            autoplay: true,
            controls: true,
            muted: false,
          })}
      </Modal>
    </div>
  );
}

export default MediaTextTitleModal;
